export default __webpack_public_path__ + "static/media/praveen.6adf0cbf.jpg";